module.exports = __webpack_public_path__ + "static/ppc-header-41f72b109cbe2e5f173f30fa96cd6258.svg";